/**
 * @Author: Zangkang
 * @Date:   2018-01-29T10:00:21+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-26T15:36:46+08:00

 */


import { Attendance } from '../constants/attendance-constants.js';
import attendanceScheduleService from '../services/Attendance/attendance-schedule-service';
import attendanceTemplateService from '../services/Attendance/attendance-template-service';
import annualLeaveService from '../services/Attendance/annual-leave-service';
import { message, Modal } from 'antd';
import _util from '../utils/index.js';
// import { push } from 'react-router-redux';
import companyCalendarService from "../services/Attendance/company-calendar-service";
import crewRosteringListService from "../services/Attendance/crew-rostering-service";
import attendanceRecordService from "../services/Attendance/attendance-record-service";
import vacationManagementService from "../services/Attendance/vacation-management-service";

// import moment from 'moment';

const dataMode = 1;


// attendance schedule

export function fetchAttendanceList(gets = { page: 1 }) {
  return dispatch => {
    attendanceScheduleService.fetchAttendanceList(gets, res => {
      // console.log(res);
      dispatch({
        type: Attendance.ActionTypes.FETCHATTENDANCESCHEDULESUCCESS,
        payload: {
          attendancePage: res.data.Page,
          attendancePageSize: res.data.PageSize,
          attendanceTotalPage: res.data.Total,
          attendanceData: res.data.Data,
          attendanceDataStatus: "loaded"
        }
      });
    }, err => { });
  }
}
export function fetchAttendanceSchedule(gets = { page: 1 }) {
  return dispatch => {
    attendanceScheduleService.fetchAttendanceSchedule(gets, res => {
      // console.log(res);
      dispatch({
        type: Attendance.ActionTypes.FETCHATTENDANCESCHEDUSCHEDULEUCCESS,
        payload: {
          schedules: res.data.Object
          // attendanceSchedulePage: res.data.Page,
          // attendanceScheduleTotalPage:res.data.Total,
          // attendanceScheduleData: res.data.Data,
          // attendanceScheduleDataStatus: "loaded"
        }
      });
    }, err => { });
  }
}
export function updateAttendanceSchedule(puts, index, callback) {
  return dispatch => attendanceScheduleService.updateAttendanceSchedule(puts, res => {
    dispatch({
      type: Attendance.ActionTypes.UPDATEATTENDANCESCHEDULESUCCESS,
      payload: {
        index: index,
        value: puts
      }
    });
    if ('function' === typeof callback) {
      callback(res.data.Success);
    }
  }, err => { })
}


// annual leave
export function fetchAnnualLeaveList(params = { page: 1 }) {
  return (dispatch) => {
    annualLeaveService.fetchAnnualLeaveList(params, (res) => {
      // console.log(res)
      if (res.data) {
        // res.data.Data.forEach(data => {
        //   data.last_settle_time = data.last_settle_time.slice(0, 10);
        //   data.expiring_date = data.expiring_date.slice(0, 10);
        // });
        // console.log(res)
        dispatch({
          type: Attendance.ActionTypes.FETCHANNUALLEAVESUCCESS,
          payload: {
            employeeList: res.data
          }
        })
      } else {
        throw new Error('获取年假列表失败')
      }
    }, (err) => {
      dispatch({
        type: Attendance.ActionTypes.FETCHANNUALLEAVEFAILURE,
        payload: {
          err
        }
      })
    })
  }
}

export function updateAnnualLeave(puts, index) {
  return (dispatch) => {
    annualLeaveService.updateAnnualLeave(puts, (res) => {
      if (res.data.Success) {
        dispatch({
          type: Attendance.ActionTypes.UPDATEANNUALLEAVESUCCESS,
          payload: {
            index: index,
            value: puts
          }
        })
        _util.successTips('修改年假记录成功')
      } else {
        _util.errorTips(res.data.Errors[0])
      }
    }, (err) => {
      dispatch({
        type: Attendance.ActionTypes.UPDATEANNUALLEAVEFAILURE,
        payload: {
          actionStatus: false
        }
      })
      console.log(err);
      _util.errorTips('修改年假记录失败')
    })
  }
}


//attendance template

function changeAttendanceTemplateAction(filters = {}, status = "loading", counter = 1) {
  return {
    type: Attendance.ActionTypes.CHANGEATTENDANCETEMPLATE,
    payload: {
      counter: counter,
      filters: filters,
      status: status
    }
  }
}

export function changeAttendanceTemplate(filters, status, counter) {
  return dispatch => dispatch(changeAttendanceTemplateAction(filters, status, counter))
}

export function selectAttendanceTemplate(gets) {
  return dispatch => {
    attendanceTemplateService.fetchAttendanceTemplateList(gets, res => {
      res.data.templates.Data.forEach(template => {
        template.start_time = template.start_time ? template.start_time.slice(0, 10) : null;
        template.end_time = template.end_time ? template.end_time.slice(0, 10) : "永久";
      });
      if (200 === res.status) {
        dispatch({
          type: Attendance.ActionTypes.FETCHATTENDANCETEMPLATESUCCESS,
          payload: {
            data: res.data.templates,
            schedules: res.data.schedules
          }
        });
      } else {
        dispatch(changeAttendanceTemplateAction({}, "error", 0))
      }
    }, err => dispatch(changeAttendanceTemplateAction({}, "error", 0)));
  }
}


// export function InitializationAttendanceTemplate(gets={template_id:''}) {
//   return dispatch => {
//     attendanceTemplateService.InitializationAttendanceTemplate(gets, res => {
//             // console.log(res.data.schedules)
//             // console.log(listData);
//             dispatch({
//               type: Attendance.ActionTypes.INITIALIZATIONSUCCESS,
//               payload: {
//                 attendanceData: res.data.schedules,
//                 attendanceDataStatus: "loaded"
//               }
//             });
//           }, err => {});
//   }
// }
export function updateAttendanceTemplate(puts, index, callback) {
  return dispatch => attendanceTemplateService.updateAttendanceTemplate(puts, res => {
    dispatch({
      type: Attendance.ActionTypes.UPDATEATTENDANCETEMPLATESUCCESS,
      payload: {
        index: index,
        value: puts
      }
    });
    if ('function' === typeof callback) {
      callback(res);
    }
  }, err => { })
}

// export function deleteAttendanceTemplate(deletes, callback) {
//   return dispatch => {
//     attendanceTemplateService.deleteAttendanceTemplate(deletes, res => {
//       if (res.data.Success && 'function' === typeof callback) {
//         callback(true);
//       }
//     }, err => {})
//   }
// }

// company calendar

export function fetchCompanyCalendarList(gets, callback) {
  return dispatch => companyCalendarService.fetchCompanyCalendarList(gets, res => {
    dispatch({
      type: Attendance.ActionTypes.FETCHCOMPANYCALENDARLISTSUCCESS,
      payload: {
        data: res.data.Data
      }
    });
    if ("function" === typeof callback) {
      callback();
    }
  })
}

//排班管理
export function fetchCrewRosteringList(gets) {
  return dispatch => {
    crewRosteringListService.fetchCrewRosteringList(gets, res => {
      console.log(res.data.Data);
      dispatch({
        type: Attendance.ActionTypes.FETCHCREWROSTERINGLISTSUCCESS,
        payload: {
          crewRosteringData: res.data.Data,
          crewRosteringPage: res.data.Page,
          crewRosteringPageSize: res.data.PageSize,
          crewRosteringTotalPage: res.data.Total,
          crewRosteringDataStatus: "loaded"
        }
      });
    }, err => { });
  }
}
export function updateCrewRostering(puts, index, callback) {
  return dispatch => crewRosteringListService.updateCrewRostering(puts, res => {
    dispatch({
      type: Attendance.ActionTypes.UPDATEATCREWROSTERINGSUCCESS,
      payload: {
        index: index,
        value: puts
      }
    });
    if ('function' === typeof callback) {
      callback(res);
    }
  }, err => { })
}

export function updateSchedule(puts, callback) {
  return dispatch => crewRosteringListService.updateSchedule(puts, res => {
    dispatch({
      type: Attendance.ActionTypes.UPDATESCHEDULESUCCESS,
      payload: {
        value: puts
      }
    });
    if ('function' === typeof callback) {
      callback(res);
    }
  }, err => { })
}

export function exportCrewRostering(data) {
  return (dispatch) => {
    crewRosteringListService.exportCrewRostering(data, (res) => {
      if (res.data.Success) {
        // let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});
        dispatch({
          type: Attendance.ActionTypes.EXPORTCREWROSTERINGSSUCCESS,
          payload: {
            fileUrl: res.data.Message
          }
        })
        // message.success(ref)
        window.open(res.data.Message);
        message.success('导出成功')
      } else {
        message.error(res.data.Errors)
        throw new Error('导出员工失败')
      }
    }, (err) => {
      dispatch({
        type: Attendance.ActionTypes.EXPORTCREWROSTERINGSSUCCESS
      })
      message.error('导出失败')
    })
  }
}

// attendace record
// export function fetchAttendanceRecord(params = {page: 1}){
//   return dispatch => attendanceRecordService.fetchAttendanceRecord(params, res => {
//     console.log(res)
//     dispatch({
//       type: Attendance.ActionTypes.FETCHATTENDANCERECORD,
//       payload: {
//      attendanceRecordPage: res.data.Page,
//      attendanceRecordTotalPage:res.data.Total,
//      attendanceRecordData: res.data.Data,
//      attendanceRecordDataStatus: "loaded"
//    }
//     });

//   })
// }
export function fetchAttendanceRecord(gets = { page: 1 }) {
  return dispatch => {
    attendanceRecordService.fetchAttendanceRecord(gets, res => {
      dispatch({
        type: Attendance.ActionTypes.FETCHATTENDANCERECORD,
        payload: {
          attendanceRecordPage: res.data.Page,
          attendanceRecordPageSize: res.data.PageSize,
          attendanceRecordTotalPage: res.data.Total,
          attendanceRecordData: res.data.Data,
          attendanceRecordDataStatus: "loaded"
        }
      });
    }, err => { });
  }
}

export function fetchExceptionAttendanceRecord(gets = { page: 1 }) {
  return dispatch => {
    attendanceRecordService.fetchExceptionAttendanceRecord(gets, res => {
      dispatch({
        type: Attendance.ActionTypes.FETCHEXCEPTIONATTENDANCERECORD,
        payload: {
          exceptionAttendanceRecordPage: res.data.Page,
          exceptionAttendanceRecordPageSize: res.data.PageSize,
          exceptionAttendanceRecordTotalPage: res.data.Total,
          exceptionAttendanceRecordData: res.data.Data,
          exceptionAttendanceRecordDataStatus: "loaded"
        }
      });
    }, err => { });
  }
}

export function updateAttendanceRecord(puts, index, callback) {
  return dispatch => attendanceRecordService.updateAttendanceRecord(puts, res => {
    dispatch({
      type: Attendance.ActionTypes.UPDATEATTENDANCERECORDSUCCESS,
      payload: {
        index: index,
        value: puts
      }
    });
    if ('function' === typeof callback) {
      callback(res);
    }
  }, err => { })
}
export function exportAttendanceRecord(data) {
  return (dispatch) => {
    let ref = Modal.info({
      content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
    });
    attendanceRecordService.exportAttendanceRecord(data, (res) => {
      if (res.data.Success) {
        ref.destroy();
        dispatch({
          type: Attendance.ActionTypes.EXPORTATTENDANCERECORDSSUCCESS,
          payload: {
            fileUrl: res.data.Message
          }
        })
        window.open(res.data.Message);
        message.success('导出成功')
      } else {
        message.error(res.data.Errors)
        throw new Error('导出失败')
      }
    }, (err) => {
      dispatch({
        type: Attendance.ActionTypes.EXPORTATTENDANCERECORDSSUCCESS
      })
      message.error('导出失败')
    })
  }
}

export function exportAttendanceExceptionRecord(data) {
  return (dispatch) => {
    let ref = Modal.info({
      content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
    });
    attendanceRecordService.exportAttendanceExceptionRecord(data, (res) => {
      if (res.data.Success) {
        ref.destroy();
        dispatch({
          type: Attendance.ActionTypes.EXPORTATTENDANEXCEPTIONCERECORDSSUCCESS,
          payload: {
            fileUrl: res.data.Message
          }
        })
        window.open(res.data.Message);
        message.success('导出成功')
      } else {
        message.error(res.data.Errors)
        throw new Error('导出失败')
      }
    }, (err) => {
      dispatch({
        type: Attendance.ActionTypes.EXPORTATTENDANEXCEPTIONCERECORDSSUCCESS
      })
      message.error('导出失败')
    })
  }
}

// vacation management

function changeVacationManagementAction(filters = "", status = "loading", counter = 1) {
  return {
    type: Attendance.ActionTypes.CHANGEVACATIONMANAGEMENT,
    payload: {
      filters: filters,
      status: status,
      counter: counter
    }
  }
}

export function changeVacationManagement(filters = "", status = "loading", counter = 1) {
  return dispatch => dispatch(changeVacationManagementAction(filters, status, counter))
}

export function selectVacationManagement(gets, callback) {
  let apiLoadStatus = false;
  return dispatch => {
    vacationManagementService.selectVacationManagement(gets, res => {
      apiLoadStatus = true;
      if (res.data.Success || dataMode === 1) {
        dispatch({
          type: Attendance.ActionTypes.SELECTVACATIONMANAGEMENT,
          payload: {
            data: res.data,
            status: "loaded"
          }
        });
      } else {
        dispatch(changeVacationManagementAction({}, "error", 0));
      }
    }, err => {
      apiLoadStatus = true;
      dispatch(changeVacationManagementAction({}, "error", 0))
    })
    setTimeout(() => {
      if (!apiLoadStatus) {
        dispatch(changeVacationManagementAction({}, "loading", 0))
      }
    }, 0);
  }
}
export function updateVacationManagement(puts, index, callback) {
  return dispatch => vacationManagementService.updateVacationManagement(puts, res => {
    if ("function" === typeof callback) {
      callback(res);
    }
    if (res.data.Success) {
      dispatch({
        type: Attendance.ActionTypes.UPDATEVACATIONMANAGEMENT,
        payload: {
          data: puts,
          index: index
        }
      });
    }
  })
}










// WEBPACK FOOTER //
// ./src/actions/attendance-actions.js